import React from 'react';
import { NavLink } from 'react-router-dom';
import { PaginationControl } from 'react-bootstrap-pagination-control';
import { dateFormat } from 'utils/Date.util';
import { getRowUnits } from 'utils/util';
import Loading from 'components/_common/Loading';

const AdminListV = ({ params, setParams, setSearch, pageChanged, handleChange, onChangeRowUnit, onSearch }) => (
    <>
        {params.isLoaded && params.error == null ? (
            <>
                <div className="content-header">
                    <h1>
                        <span>관리자 관리</span>
                    </h1>
                </div>
                <div className="container-fluid">
                    <div className="card">
                        <div className="card-header p-0 mt_20">
                            <div className="card-header-left"></div>
                            <div className="card-header-right">
                                <NavLink to="add">
                                    <button className="btn btn-primary" type="button">
                                        등록
                                    </button>
                                </NavLink>
                            </div>
                        </div>
                        <div className="card-header p-0 mt_20">
                            <div className="card-header-left">
                                <div className="g_table_sort">
                                    <span className="g_select">
                                        <select className="form-control" onChange={onChangeRowUnit} value={params.search.rows}>
                                            {getRowUnits().map((item, index) => (
                                                <option key={index} value={item}>
                                                    {item}
                                                </option>
                                            ))}
                                        </select>
                                    </span>
                                    / {params?.total?.toLocaleString()} rows
                                </div>
                            </div>

                            <div className="card-header-right">
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <select className="form-control" value={params.searchType} onChange={(e) => handleChange(e, 'searchType', setParams, params)} style={{ borderRadius: '0.25rem 0 0 0.25rem' }}>
                                            <option value="name">이름</option>
                                            <option value="username">계정ID</option>
                                        </select>
                                    </div>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="키워드 입력"
                                        value={params.keyword || ''}
                                        onChange={(e) => handleChange(e, 'keyword', setParams, params)}
                                        onKeyDown={(e) => e.key === 'Enter' && onSearch()} // 엔터키를 눌렀을 때 검색 함수 호출
                                    />
                                    <div className="input-group-append">
                                        <button className="btn btn-outline-secondary" type="button" onClick={onSearch}>
                                            <i className="fas fa-search"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card-body table-responsive p-0">
                            <table className="table text-nowrap">
                                <thead>
                                    <tr>
                                        <th>No</th>
                                        <th className="tal">이름</th>
                                        {/* <th className="tal">접근가능 메뉴</th> */}
                                        <th className="tal">계정ID</th>
                                        {/* <th className="tal">전화번호</th> */}
                                        {/* <th className="tal">이메일</th> */}
                                        <th>등록일</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {params.isLoaded && params.error == null && (
                                        <>
                                            {params.items.map((item, index) => (
                                                <tr key={item.username}>
                                                    <td>{params.search.rows * params.search.page - (params.search.rows - (index + 1))}</td>
                                                    <td className="tal">{item.name} </td>
                                                    {/* <td className="tal">{item.roles == 'master' ? '마스터 관리자' : item.roles == 'admin' ? '일반관리자' : '배송관리자'}</td> */}
                                                    <td className="tal">
                                                        <NavLink to={'update/' + item.username}>{item.username}</NavLink>
                                                    </td>
                                                    {/* <td className="tal">{item.phone} </td> */}
                                                    {/* <td className="tal">{item.email} </td> */}
                                                    <td>{dateFormat(new Date(item.regdate))} </td>
                                                </tr>
                                            ))}
                                        </>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        <PaginationControl
                            page={params.search.page}
                            total={params.total}
                            limit={params.search.rows}
                            changePage={(page) => {
                                pageChanged(page, params.search, setParams, setSearch);
                            }}
                            ellipsis={1}
                        />
                    </div>
                </div>
            </>
        ) : (
            <Loading />
        )}
    </>
);

export default AdminListV;
